import en from './en';
import type { TranslationSchema } from './en';

const ml: TranslationSchema = {
    ...en,
};

export default ml;
